import { RadioTextFilterOperation } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';

export const URL_PLACEHOLDERS = {
  [RadioTextFilterOperation.CONTAINS]: 'e.g. register',
  [RadioTextFilterOperation.STARTS_WITH]: 'e.g. https://example.com/',
  [RadioTextFilterOperation.ENDS_WITH]: 'e.g. /contact',
  [RadioTextFilterOperation.IS_EXACTLY]: 'e.g. https://example.com/page',
  [RadioTextFilterOperation.IS]: 'e.g. example.com/page',
  [RadioTextFilterOperation.REGEX]: 'e.g. /page/[^/]+',
};
